<div class="h-100 overflow-hidden">
  <!-- <div class="page-title-block bg-white flex-wrap flex-sm-nowrap" *ngIf="signaturesAvailable.value">
    <div class="title-block-left">
      <button mat-button mat-stroked-button color="dark" class="button-default my-custom-setting" (click)="addSignature()">
        <span class="mat-button-wrapper">
          <i class="fa-regular fa-plus"></i>
          Add Signature
        </span>
      </button>
    </div>
    <div class="title-block-right">
      <div class="search-block gap-8">
        <mat-form-field class="fixed-label label-none flex-1 icon-form-before" floatLabel="always">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search" type="text" maxlength="50" [(ngModel)]="searchText">
          <span matPrefix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
          </span>
        </mat-form-field>
      </div>
    </div>
  </div> -->

  <div class="content-block-main ps-0">
    <div class="signatures-body cards-groups gap-20 column-gap-20">
      @if(signaturesAvailable()){
        <ng-container *ngIf="(allSignaturesData | signatureFilter : searchText()) as result">
          <mat-list class="flexbox-row w-100 mat-list-base flex-wrap signature-list">
            <mat-list-item *ngFor="let sign of result; let i = index">
              <div class="card flex-1 add-card-header-height">
                  <div class="card-header d-flex flex-row align-items-center justify-content-between border-0">
                    <div class="w-100">
                      <div class="d-flex flex-row align-items-center justify-content-between">
                        <ng-container *ngIf="!sign.isSignatureEdit">
                          <div class="flex-row d-flex hover-action w-200">
                           <span class="text-ellipse fw-semibold" title="{{sign.signature}}">{{sign.signature}}</span>
                              <button mat-button class="button-medium-icon-action hover-action-item"
                                (click)="validateUnsavedChanges(sign, 'edit');$event.stopPropagation();">
                                <i class="fa-regular fa-pen fs-15"></i>
                              </button>
                          </div>
                          <mat-slide-toggle (click)="validateUnsavedChanges(sign, 'selection')"
                            *ngIf="sign.isuserselected !== 1"><p class="fw-semibold">Set as Default</p>
                          </mat-slide-toggle>
                          <p class="Progress badge badge-In badge-purple badge-small" *ngIf="sign.isuserselected === 1">
                            Default</p>
                          <button mat-button mat-stroked-button color="primary" [disabled]="sign.isuserselected === 1"
                            (click)="validateUnsavedChanges(sign, 'delete')" class="button-default-icon border-0">
                            <i class="fa-regular fa-trash-can"></i>
                          </button>
                        </ng-container>

                        <ng-container *ngIf="sign.isSignatureEdit">
                          <div class="flexbox-row justify-content-between w-100">
                          <mat-form-field class="fixed-label input-field-editable icon-form-after action-2"
                            floatLabel="always">
                            <input matInput type="text" #signatureNameEdit [(ngModel)]="sign.signature" onkeypress="return /[0-9a-zA-Z ]/i.test(event.key)"
                            (blur)="onSignatureEditBlur($event,buttonSection,sign);$event.preventDefault()">
                            <div matSuffix class="actions border-left">
                              <button mat-button color="success" #buttonSection
                                [disabled]="sign.signature === null || sign.signature === ''"
                                (click)="saveSignatureName(sign);$event.stopPropagation();">
                                <i class="fa-regular fa-check"></i>
                              </button>
                              <button mat-button color="cancel" (click)="closeSignature(sign);$event.stopPropagation();">
                                <i class="fa-regular fa-xmark clear-icon"></i>
                              </button>
                            </div>
                          </mat-form-field>
                          <mat-slide-toggle (click)="validateUnsavedChanges(sign, 'selection')"
                            *ngIf="sign.isuserselected !== 1"><p class="fw-semibold">Set as Default</p>
                          </mat-slide-toggle>
                          <p class="Progress badge badge-In badge-purple badge-small" *ngIf="sign.isuserselected === 1">
                            Default</p>
                          <button mat-button mat-stroked-button color="primary" [disabled]="sign.isuserselected === 1"
                            (click)="validateUnsavedChanges(sign, 'delete')" class="button-default-icon border-0">
                            <i class="fa-regular fa-trash-can"></i>
                          </button>
                           </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                <div class="card-body py-1" *ngIf="sign.signature_type !== signatureType?.TEXT">
                  <div class="image-sign-height flexbox-row justify-content-start">
                    <img [src]="sign.s3JSONFilePath" />
                  </div>

                </div>
                <div class="card-body py-1" *ngIf="sign.signature_type === signatureType?.TEXT">
                  <div class="image-sign-height flexbox-row justify-content-start">
                  <div title="{{sign?.signature_text}}" class="font-sign signature-text text-ellipse">{{sign?.signature_text}}</div>
                </div>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
          <div class="card h-500" *ngIf="result?.length === 0 && searchText">
            <div class="no-data-found">
              <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
              <h6>No Results found</h6>
            </div>
          </div>
        </ng-container>
      }
    </div>
    @if(!signaturesAvailable()){
      <div class="h-100">
        <div class="no-data-found">
          <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
          <h6>No Signatures Added</h6>
          <p>You have not added any signatures.</p>
          <p>Please click on the button to add signatures</p>
          <button mat-button mat-flat-button color="primary" class="button-default" (click)="addSignature();$event.stopPropagation();">
            <div class="flexbox-row gap-8">
                <i class="fa-solid fa-plus"></i>
                <span class="button-label">Add Signature</span>
            </div>
          </button>
        </div>
      </div>
    }
  </div>

</div>



<ng-template #deletesignatureDialog>
  <div class="countable-dialog confirmation-dailog eletesignatureDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title">Delete Signature</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>Are you sure you want to delete this signature?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true">Delete</button>
    </div>
  </div>
</ng-template>

<ng-template #alertUnsavedChangesDialog>
  <div class="countable-dialog confirmation-dailog alertUnsavedChangesDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">Unsaved Changes</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>There are unsaved changes.</p>
      <p>Do you want to save ?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]
        (click)="cancelUnsavedChanges()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
        (click)="saveUnsavedChanges()">Yes</button>
    </div>
  </div>
</ng-template>

<ng-template #addSignatureDialog>
  <div class="countable-dialog w-400 addSignatureDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header flexbox-column justify-content-between">
      <h4 class="title"> Add Signature</h4>
      <button mat-button class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div mat-dialog-content class="content dialog-body-content text-center gap-16 pt-3">
      <div class="d-flex w-100 select-sign-type">
        <mat-radio-group [disabled]="false" [(ngModel)]="addSignatureType" (click)="changeTab($event)">
          <mat-radio-button class="example-margin pr-w" [checked]="addSignatureType === signatureType?.DRAW"
            [value]="signatureType?.DRAW">Draw</mat-radio-button>
          <mat-radio-button class="example-margin pr-w" [value]="signatureType?.TEXT">Type</mat-radio-button>
          <mat-radio-button class="example-margin" [value]="signatureType?.UPLOAD">Upload</mat-radio-button>
        </mat-radio-group>
      </div>
      <ng-container *ngIf="addSignatureType === signatureType?.DRAW">
        <div class="justify-content-center flexbox-column w-100 br-8 h-200">
            <app-signature-pad (signatureDrawn)="getCanvasSignature($event)"></app-signature-pad>
        </div>
      </ng-container>
      <ng-container *ngIf="addSignatureType === signatureType?.TEXT">
        <div class="justify-content-center flexbox-column w-100 br-8 bg-gray-1 p-4 mt-2 h-200">
          <mat-form-field class="fixed-label label-none w-100 border-0 sign-form-field signature-text"
            floatLabel="always">
            <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="2" placeholder="Type your Signature" onkeypress="return /[0-9a-zA-Z ]/i.test(event.key)" (keyup)="checkValidForm()" [(ngModel)]="signatureText"></textarea>
          </mat-form-field>
        </div>
      </ng-container>

      <ng-container *ngIf="addSignatureType === signatureType?.UPLOAD">
        <div class="justify-content-center flexbox-column w-100 br-8">
          <div class="file-upload" *ngIf="!previewImage" appDragDrop
            (onFileDropped)="uploadSignature($event, 'dnd','Signature')">
            <div class="upload-icon">
                <i class="fa-regular fa-cloud-arrow-up"></i>
            </div>
            <div class="file-wrapper">
              <input type="file" name="photo" id="photo" accept="image/*"
                (change)="uploadSignature($event, 'manual','Signature')">
              <p class="text-link text-primary fw-medium m-0">Click to add signature <span
                  class="text-gray-6 fw-regular">or
                  drag and drop <br />PNG, JPG or GIF</span>
              </p><br>
              <p class="mb-3"><span class="fw-bold">Recommended Resolution:</span>
                We recommend an image resolution of 200x125 pixels for optimal clarity and best fit.</p>
            </div>
          </div>
          <div class="w-100" *ngIf="previewImage">
            <button class="transparent-btn remove-btn p-0 d-flex align-items-center mb-1" (click)="removeImage()">
              <svg width="16" height="16" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.3333 4.99984V4.33317C12.3333 3.39975 12.3333 2.93304 12.1517 2.57652C11.9919 2.26292 11.7369 2.00795 11.4233 1.84816C11.0668 1.6665 10.6001 1.6665 9.66667 1.6665H8.33333C7.39991 1.6665 6.9332 1.6665 6.57668 1.84816C6.26308 2.00795 6.00811 2.26292 5.84832 2.57652C5.66667 2.93304 5.66667 3.39975 5.66667 4.33317V4.99984M7.33333 9.58317V13.7498M10.6667 9.58317V13.7498M1.5 4.99984H16.5M14.8333 4.99984V14.3332C14.8333 15.7333 14.8333 16.4334 14.5608 16.9681C14.3212 17.4386 13.9387 17.821 13.4683 18.0607C12.9335 18.3332 12.2335 18.3332 10.8333 18.3332H7.16667C5.76654 18.3332 5.06647 18.3332 4.53169 18.0607C4.06129 17.821 3.67883 17.4386 3.43915 16.9681C3.16667 16.4334 3.16667 15.7333 3.16667 14.3332V4.99984" stroke="#004B92" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <h6 class="d-inline-block text-primary ml-2">Remove</h6>
            </button>
            <div class="justify-content-center flexbox-row w-100 br-8 bg-gray-1" style="height: 160px;">
                <p class="d-flex flex-column gap-4">
                    <img src="{{previewImage}}" width="214" height="61">
                </p>
            </div>
        </div>
        </div>
      </ng-container>
      <div class="d-flex align-items-left flex-column w-100 br-8 w-100 signature-name">
        <mat-form-field class="fixed-label" floatLabel="always">
          <mat-label>Name your signature</mat-label>
          <input matInput type="text" required placeholder="Signature Name" [(ngModel)]="signatureName"
          onkeypress="return /[0-9a-zA-Z ]/i.test(event.key)" (keyup)="checkValidForm()">
        </mat-form-field>
      </div>
    </div>
    <div mat-dialog-actions class="dialog-footer button-group">
      <button mat-button mat-stroked-button class="button-large" color="dark" [mat-dialog-close]="false">Cancel
      </button>
      <button mat-button mat-flat-button class="button-large" [disabled]="disableSave" color="primary"
        [mat-dialog-close]="true">Save
      </button>
    </div>
  </div>
</ng-template>
